// Load SVGs
import staticUrl from "../../app/utils/staticPath";

const icons = (function () {
  const loadIcons = function () {

    const baseURL = `${staticUrl()}assets/images/svg/`;
    $.get(`${baseURL}master.svg`, function (data) {
      const div = document.createElement(`div`);
      div.className += `master-svg`;
      div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
      document.body.insertBefore(div, document.body.childNodes[0]);
    });
  };
  loadIcons();
}());



// WEBPACK FOOTER //
// ./library/js/modules/icons.js